<template>
      <div class="relative flex-1 px-4 sm:px-6">
        <div class="space-y-4 options">
          <div class="flex justify-between items-start">
            <h2 class="text-base font-semibold tracking-wide md:text-xl text-gray-50">Props</h2>
            <div @click.prevent="$emit('close')"
             class="px-2 py-1 -mx-2 -my-2 text-white rounded-full cursor-pointer hover:bg-gray-100 hover:text-gray-700 hover:ring-white">
              <i class=" fas fa-chevron-down"></i>
            </div>
          </div>

          <div class="mt-4 space-y-8 props">

            <!-- Prop -->
            <div class="flex prop">
              <div class="flex items-center w-40">
                <h2 class="text-xs font-medium tracking-wide text-gray-100 uppercase md:text-sm">Prop One</h2>
              </div>

              <nav aria-label="Progress" class="flex justify-start">

                <ol role="list" class="flex items-center">
                  <li class="relative pr-8 sm:pr-12 md:pr-20 lg:pr-24">
                    <!-- Complete Step -->
                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                      <div class="h-0.5 w-full"
                      :class="[
                        state.prop1 >= 1
                          ? 'bg-indigo-800'
                          : 'bg-gray-200',
                      ]"></div>
                    </div>
                    <a href="#"
                      :class="[
                        state.prop1 >= 0
                          ? 'bg-white border-2 border-indigo-600 hover:bg-indigo-400'
                          : 'bg-white border-2 border-gray-300 hover:border-indigo-700 hover:bg-indigo-400',
                      ]"
                      class="relative flex items-center justify-center w-8 h-8 rounded-full"
                      @click.prevent="$emit('change', { key: 'prop1', value: 0 })">
                      <span class="h-2.5 w-2.5 rounded-full"
                        :class="[
                          state.prop1 >= 0
                            ? 'bg-indigo-600 '
                            : 'bg-transparent group-hover:bg-gray-300',
                        ]" aria-hidden="true"></span>
                      <span class="sr-only">Step 1</span>
                    </a>
                  </li>

                  <li class="relative pr-8 sm:pr-12 md:pr-20 lg:pr-24">
                    <!-- Complete Step -->
                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                      <div class="h-0.5 w-full"
                      :class="[
                        state.prop1 >= 2
                          ? 'bg-indigo-800'
                          : 'bg-gray-200',
                      ]"></div>
                    </div>
                    <a href="#"
                      :class="[
                        state.prop1 >= 1
                          ? 'bg-white border-2 border-indigo-600 hover:bg-indigo-400'
                          : 'bg-white border-2 border-gray-300 hover:border-indigo-700 hover:bg-indigo-400',
                      ]"
                      class="relative flex items-center justify-center w-8 h-8 rounded-full"
                      @click.prevent="$emit('change', { key: 'prop1', value: 1 })">
                      <span class="h-2.5 w-2.5 rounded-full"
                        :class="[
                          state.prop1 >= 1
                            ? 'bg-indigo-600 '
                            : 'bg-transparent group-hover:bg-gray-300',
                        ]" aria-hidden="true"></span>
                      <span class="sr-only">Step 2</span>
                    </a>
                  </li>

                  <li class="relative pr-8 sm:pr-12 md:pr-20 lg:pr-24">
                    <!-- Current Step -->
                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                      <div class="h-0.5 w-full"
                      :class="[
                        state.prop1 >= 3
                          ? 'bg-indigo-800'
                          : 'bg-gray-200',
                      ]"></div>
                    </div>
                    <a href="#"
                      :class="[
                        state.prop1 >= 2
                          ? 'bg-white border-2 border-indigo-600 hover:bg-indigo-400'
                          : 'bg-white border-2 border-gray-300 hover:border-indigo-700 hover:bg-indigo-400',
                      ]"
                      class="relative flex items-center justify-center w-8 h-8 rounded-full"
                      @click.prevent="$emit('change', { key: 'prop1', value: 2 })">
                      <span class="h-2.5 w-2.5 rounded-full"
                        :class="[
                          state.prop1 >= 2
                            ? 'bg-indigo-600 '
                            : 'bg-transparent group-hover:bg-gray-300',
                        ]" aria-hidden="true"></span>
                      <span class="sr-only">Step 3</span>
                    </a>
                  </li>

                  <li class="relative pr-8 sm:pr-12 md:pr-20 lg:pr-24">
                    <!-- Upcoming Step -->
                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                      <div class="h-0.5 w-full"
                      :class="[
                        state.prop1 >= 4
                          ? 'bg-indigo-800'
                          : 'bg-gray-200',
                      ]"></div>
                    </div>
                    <a href="#"
                      :class="[
                        state.prop1 >= 3
                          ? 'bg-white border-2 border-indigo-600 hover:bg-indigo-400'
                          : 'bg-white border-2 border-gray-300 hover:border-indigo-700 hover:bg-indigo-400',
                      ]"
                      class="relative flex items-center justify-center w-8 h-8 rounded-full"
                      @click.prevent="$emit('change', { key: 'prop1', value: 3 })">
                      <span class="h-2.5 w-2.5 rounded-full"
                        :class="[
                          state.prop1 >= 3
                            ? 'bg-indigo-600 '
                            : 'bg-transparent group-hover:bg-gray-300',
                        ]" aria-hidden="true"></span>
                      <span class="sr-only">Step 4</span>
                    </a>
                  </li>

                  <li class="relative">
                    <!-- Upcoming Step -->
                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                      <div class="h-0.5 w-full"
                      :class="[
                        state.prop1 >= 4
                          ? 'bg-indigo-800'
                          : 'bg-gray-200',
                      ]"></div>
                    </div>
                    <a href="#"
                      :class="[
                        state.prop1 >= 4
                          ? 'bg-white border-2 border-indigo-600 hover:bg-indigo-400'
                          : 'bg-white border-2 border-gray-300 hover:border-indigo-700 hover:bg-indigo-400',
                      ]"
                      class="relative flex items-center justify-center w-8 h-8 rounded-full"
                      @click.prevent="$emit('change', { key: 'prop1', value: 4 })">
                      <span class="h-2.5 w-2.5 rounded-full"
                        :class="[
                          state.prop1 >= 4
                            ? 'bg-indigo-600 '
                            : 'bg-transparent group-hover:bg-gray-300',
                        ]" aria-hidden="true"></span>
                      <span class="sr-only">Step 5</span>
                    </a>
                  </li>
                </ol>
              </nav>

            </div>

            <!-- Prop -->
            <div class="flex prop">
              <div class="flex items-center w-40"><h2 class="text-xs font-medium tracking-wide text-gray-100 uppercase md:text-sm">Prop Two</h2></div>

              <nav aria-label="Progress" class="flex justify-start">

                <ol role="list" class="flex items-center">
                  <li class="relative pr-8 sm:pr-12 md:pr-20 lg:pr-24">
                    <!-- Complete Step -->
                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                      <div class="h-0.5 w-full"
                      :class="[
                        state.prop2 >= 1
                          ? 'bg-indigo-800'
                          : 'bg-gray-200',
                      ]"></div>
                    </div>
                    <a href="#"
                      :class="[
                        state.prop2 >= 0
                          ? 'bg-white border-2 border-indigo-600 hover:bg-indigo-400'
                          : 'bg-white border-2 border-gray-300 hover:border-indigo-700 hover:bg-indigo-400',
                      ]"
                      class="relative flex items-center justify-center w-8 h-8 rounded-full"
                      @click.prevent="$emit('change', { key: 'prop2', value: 0 })">
                      <span class="h-2.5 w-2.5 rounded-full"
                        :class="[
                          state.prop2 >= 0
                            ? 'bg-indigo-600 '
                            : 'bg-transparent group-hover:bg-gray-300',
                        ]" aria-hidden="true"></span>
                      <span class="sr-only">Step 1</span>
                    </a>
                  </li>

                  <li class="relative pr-8 sm:pr-12 md:pr-20 lg:pr-24">
                    <!-- Complete Step -->
                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                      <div class="h-0.5 w-full"
                      :class="[
                        state.prop2 >= 2
                          ? 'bg-indigo-800'
                          : 'bg-gray-200',
                      ]"></div>
                    </div>
                    <a href="#"
                      :class="[
                        state.prop2 >= 1
                          ? 'bg-white border-2 border-indigo-600 hover:bg-indigo-400'
                          : 'bg-white border-2 border-gray-300 hover:border-indigo-700 hover:bg-indigo-400',
                      ]"
                      class="relative flex items-center justify-center w-8 h-8 rounded-full"
                      @click.prevent="$emit('change', { key: 'prop2', value: 1 })">
                      <span class="h-2.5 w-2.5 rounded-full"
                        :class="[
                          state.prop2 >= 1
                            ? 'bg-indigo-600 '
                            : 'bg-transparent group-hover:bg-gray-300',
                        ]" aria-hidden="true"></span>
                      <span class="sr-only">Step 2</span>
                    </a>
                  </li>

                  <li class="relative pr-8 sm:pr-12 md:pr-20 lg:pr-24">
                    <!-- Current Step -->
                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                      <div class="h-0.5 w-full"
                      :class="[
                        state.prop2 >= 3
                          ? 'bg-indigo-800'
                          : 'bg-gray-200',
                      ]"></div>
                    </div>
                    <a href="#"
                      :class="[
                        state.prop2 >= 2
                          ? 'bg-white border-2 border-indigo-600 hover:bg-indigo-400'
                          : 'bg-white border-2 border-gray-300 hover:border-indigo-700 hover:bg-indigo-400',
                      ]"
                      class="relative flex items-center justify-center w-8 h-8 rounded-full"
                      @click.prevent="$emit('change', { key: 'prop2', value: 2 })">
                      <span class="h-2.5 w-2.5 rounded-full"
                        :class="[
                          state.prop2 >= 2
                            ? 'bg-indigo-600 '
                            : 'bg-transparent group-hover:bg-gray-300',
                        ]" aria-hidden="true"></span>
                      <span class="sr-only">Step 3</span>
                    </a>
                  </li>

                  <li class="relative pr-8 sm:pr-12 md:pr-20 lg:pr-24">
                    <!-- Upcoming Step -->
                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                      <div class="h-0.5 w-full"
                      :class="[
                        state.prop2 >= 4
                          ? 'bg-indigo-800'
                          : 'bg-gray-200',
                      ]"></div>
                    </div>
                    <a href="#"
                      :class="[
                        state.prop2 >= 3
                          ? 'bg-white border-2 border-indigo-600 hover:bg-indigo-400'
                          : 'bg-white border-2 border-gray-300 hover:border-indigo-700 hover:bg-indigo-400',
                      ]"
                      class="relative flex items-center justify-center w-8 h-8 rounded-full"
                      @click.prevent="$emit('change', { key: 'prop2', value: 3 })">
                      <span class="h-2.5 w-2.5 rounded-full"
                        :class="[
                          state.prop2 >= 3
                            ? 'bg-indigo-600 '
                            : 'bg-transparent group-hover:bg-gray-300',
                        ]" aria-hidden="true"></span>
                      <span class="sr-only">Step 4</span>
                    </a>
                  </li>

                  <li class="relative">
                    <!-- Upcoming Step -->
                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                      <div class="h-0.5 w-full"
                      :class="[
                        state.prop2 >= 4
                          ? 'bg-indigo-800'
                          : 'bg-gray-200',
                      ]"></div>
                    </div>
                    <a href="#"
                      :class="[
                        state.prop2 >= 4
                          ? 'bg-white border-2 border-indigo-600 hover:bg-indigo-400'
                          : 'bg-white border-2 border-gray-300 hover:border-indigo-700 hover:bg-indigo-400',
                      ]"
                      class="relative flex items-center justify-center w-8 h-8 rounded-full"
                      @click.prevent="$emit('change', { key: 'prop2', value: 4 })">
                      <span class="h-2.5 w-2.5 rounded-full"
                        :class="[
                          state.prop2 >= 4
                            ? 'bg-indigo-600 '
                            : 'bg-transparent group-hover:bg-gray-300',
                        ]" aria-hidden="true"></span>
                      <span class="sr-only">Step 5</span>
                    </a>
                  </li>
                </ol>
              </nav>

            </div>

          </div>



        </div>
      </div>
</template>
<script>
export default {
  props: {
    state: {
      type: Object,
      default: null
    }
  }
}
</script>
